import { Component } from '@verndale/core';
import { BREAKPOINTS } from '../constants';
import { KEYS, KEYS_DIRECTION } from '../constants';
import { v4 as uuidv4 } from 'uuid';
import { debounce } from 'lodash';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tabTriggers: this.el._$$('.virtual-tour-row__tab-button'),
      $tabPanels: this.el._$$('.virtual-tour-row__tab-panel'),
      $accordionTriggers: this.el._$$('.virtual-tour-row__accordion-button'),
      $tabContents: this.el._$$('.virtual-tour-row__tab-content'),
      $tabPanelsContainer: this.el._$('.virtual-tour-row__tab-panels-container')
    };

    if (!this.dom.$tabContents.length) this.el.classList.add('virtual-tour-row--empty')

    this.canLoadIframes = false;
    this.checkUserCookiesPreferences();
    if (this.canLoadIframes) this.loadIframes();
    else this.el.style.display = 'none';

    this.init();
    if (!this.el.classList.contains('isExperienceEditor')) {
      this.movePanels();
    } else {
      this.openAllPanels();
    }
  }

  init() {
    this.tabTriggersLength = this.dom.$tabTriggers.length;
    this.accordionTriggersLength = this.dom.$accordionTriggers.length;
    this.selectedTab = 0;
    this.prevSelectedTab = null;
    window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`).matches ? this.isAccordion = false : this.isAccordion = true;

    if (this.isAccordion) {
      this.dom.$tabPanels.forEach((el, i) => {
        el.hidden = false

        if (el.classList.contains('is-open')) {
          this.show(i)
        } else {
          this.hide(i)

        }

      });
    } else {

      this.dom.$tabTriggers.forEach((el, i) => {
        el.index = i;
        if (el.classList.contains('is-selected')) {
          this.selectedTab = i;
        }


        this.hide(i)

      });
      this.dom.$accordionTriggers.forEach((el, i) => {
        el.index = i;
        if (el.classList.contains('is-selected')) {
          this.selectedTab = i;
        }
        this.hide(i)
      });
    }

    this.selectTab(this.selectedTab, false);
  }

  movePanels() {
    this.dom.$tabPanels.forEach(el => {
      this.dom.$tabPanelsContainer.appendChild(el);
    })
    this.dom.$tabPanels[0].classList.add('is-selected');
  }

  openAllPanels() {
    this.dom.$tabPanels.forEach((el, index) => {
      this.show(index, true)
    })
  }

  addListeners() {
    if (!this.el.classList.contains('isExperienceEditor')) {
      this.dom.$tabTriggers._on('click', this.handleTabClick.bind(this));
      this.dom.$accordionTriggers._on('click', this.handleTabClick.bind(this));
      this.dom.$tabTriggers._on('keydown', this.handleKeyDown.bind(this));
      this.dom.$accordionTriggers._on('keydown', this.handleKeyDown.bind(this));
      window.addEventListener('resize', debounce(this.init.bind(this), 300));
    }
  }

  checkUserCookiesPreferences() {
    // Initial tests doesn't show Matterport inserting cookies unless you have already login accepted them on their site
    //TO-DO:  confirm that Matterport does not insert cookies
    this.canLoadIframes = true;
  }

  loadIframes() {
    this.dom.$tabContents.forEach(el => {
      el.innerHTML = el.dataset.iframe;
    })
  }

  show(index, userTriggered) {
    this.dom.$tabPanels[index].removeAttribute('tabindex');
    this.dom.$tabTriggers[index].removeAttribute('tabindex');
    this.dom.$tabTriggers[index].classList.add('is-selected');
    this.dom.$tabTriggers[index].setAttribute('aria-selected', true);

    this.dom.$accordionTriggers[index].setAttribute('aria-expanded', true);
    this.dom.$accordionTriggers[index].classList.add('is-selected');


    const panelContent = this.dom.$tabPanels[index].getElementsByClassName('virtual-tour-row__tab-content')[0];
    panelContent.setAttribute('aria-hidden', false);
    panelContent.hidden = false;
    panelContent.classList.add('is-open');

    this.dom.$tabPanels[index].hidden = false;
    this.dom.$tabPanels[index].classList.add('is-open');

    if (userTriggered) {
      this.dom.$tabTriggers[index].focus();
    }
  }

  hide(index) {
    this.dom.$tabTriggers[index].classList.remove('is-selected');
    this.dom.$tabTriggers[index].setAttribute('aria-selected', false);
    this.dom.$tabTriggers[index].setAttribute('tabindex', -1);

    this.dom.$accordionTriggers[index].setAttribute('aria-expanded', false);
    this.dom.$accordionTriggers[index].classList.remove('is-selected');

    const panelContent = this.dom.$tabPanels[index].getElementsByClassName('virtual-tour-row__tab-content')[0];
    panelContent.setAttribute('aria-hidden', true);
    panelContent.classList.remove('is-open');
    panelContent.hidden = true;

    this.dom.$tabPanels[index].classList.remove('is-open');
    if (!this.isAccordion) this.dom.$tabPanels[index].hidden = true;
    this.dom.$tabPanels[index].setAttribute('tabindex', -1);
  }

  selectTab(index, userTriggered) {
    if (index === null) {
      if (this.isAccordion) {
        return;
      } index = 0;
    }

    if (!this.dom.$tabPanels[index].getElementsByClassName('virtual-tour-row__tab-content')[0].hidden && userTriggered && this.isAccordion) {

      if (index === this.selectedTab) {
        this.selectedTab = null;
      } else {
        this.selectedTab = null;
        this.prevSelectedTab = index;
      }
      this.hide(index);
      return;
    }

    if (this.isAccordion) {
      this.prevSelectedTab = this.selectedTab;
      this.selectedTab = index;
    } else {
      if (this.prevSelectedTab === null || !this.isAccordion) {
        this.dom.$tabTriggers.forEach((el, i) => {
          if (i !== index) {
            this.hide(i);
          }
        })
      }
    }

    this.prevSelectedTab = this.selectedTab;
    this.selectedTab = index;

    this.show(this.selectedTab, userTriggered);

  }

  handleTabClick(e) {
    let index = this.dom.$tabTriggers.indexOf(e.currentTarget)
    if (index >= 0) this.selectTab(index)
    else {
      index = this.dom.$accordionTriggers.indexOf(e.currentTarget)
      this.selectTab(index, true)
    }
  }

  handleKeyDown(e) {
    let targetIndex;

    if (e.keyCode === KEYS.ENTER) {
      this.startPlay();
    }

    if (e.keyCode === KEYS.LEFT || e.keyCode === KEYS.RIGHT || e.keyCode === KEYS.SPACE || e.keyCode === KEYS.ENTER) {
      e.preventDefault();
    } else {
      return;
    }

    if (e.keyCode === KEYS.LEFT && e.target.index > 0 && !this.isAccordion) {
      targetIndex = e.target.index - 1;
    } else if (e.keyCode === KEYS.RIGHT && e.target.index < this.tabTriggersLength - 1 && !this.isAccordion) {
      targetIndex = e.target.index + 1;
    } else if (e.keyCode === KEYS.SPACE || e.keyCode === KEYS.ENTER) {
      targetIndex = e.target.index;
    } else {
      return;
    }


    this.selectTab(targetIndex, true);
  }

  startPlay() {
    const iframe = this.el._$('.virtual-tour-row__tab-content.is-open iframe');
    const src = iframe.src;

    iframe.src = `${src}&play=1`;
    iframe.onload = () => {
      iframe.contentWindow.focus();
    }
  }
}

export default Module;
